import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { scrollToSection } from "../lib/utils";
import FadeInComponent from "./FadeInComponent";
import RoundedButton from "./RoundedButton";
import React from "react";

export default function LandingSection() {
  const theme = useTheme();

  const handleScroll = () => {
    scrollToSection("services-section");
  };

  return (
    <Box
      sx={{
        px: { xs: 0, md: 3 },
        pt: 0,
      }}
    >
      <Box
        sx={{
          backgroundImage:
            "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.36) 60%, rgba(0,0,0,0.08) 100%), url(https://cdn.prod.website-files.com/6737288294995c3cfebf9e63/678a5209a16df632fc327b49_hero.jpg)",
          backgroundSize: "cover",
          backgroundPosition: {
            xs: "center",
            sm: "center",
            md: "center",
            lg: "center 35%",
            xl: "center 30%",
          },
          height: {
            xs: 600,
            sm: 700,
            md: 600,
            lg: 700,
            xl: 800,
          },
          maxHeight: {
            lg: 800,
            xl: 900,
          },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          px: {
            xs: "var(--section-margin-x, 40px)",
            md: "calc(var(--section-margin-x, 40px) - 24px)",
          },
          pb: { xs: 4, sm: 6, md: 8 },
          position: "relative",
          borderRadius: { xs: 0, md: 3, lg: 4 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            color: theme.palette.text.primary,
            maxWidth: 900,
          }}
        >
          <FadeInComponent delay={0.4}>
            <Typography
              variant="h1"
              sx={{
                color: theme.palette.text.primary,
                mb: 1.5,
              }}
            >
              Centre de Recherche en rhumatologie GRMO - Québec
            </Typography>
          </FadeInComponent>
          <FadeInComponent delay={0.5}>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                mb: 3,
              }}
            >
              Études cliniques avancées en rhumatologie et physiatrie, offrant
              aux patients un accès à des thérapies innovantes et un suivi
              personnalisé.
            </Typography>
          </FadeInComponent>
          <FadeInComponent delay={0.6}>
            <RoundedButton title="Nos services" onClick={handleScroll} />
          </FadeInComponent>
        </Box>
      </Box>
    </Box>
  );
}
